
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActionSheetController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { logger } from 'src/app/common/services/logging/logging.service';
import { UserService } from 'src/app/common/services/user/user.service';
import { environment } from 'src/environments/environment';
import { PlatformService } from './platform.service';


@Injectable({
    providedIn: 'root'
})
export class EnvironmentService {

    protected environment = environment;

    private static environmentList: Environment[] = [];

    constructor(
        private http: HttpClient, // Inject HttpClient
        private actionSheetCtrl: ActionSheetController,
        private srvUser: UserService
    ) {
        this.initEnvironmentList();
    }

    public async initEnvironmentList() {
        if (PlatformService.isBrowser()) return;

        try {
            const list = await firstValueFrom(
                this.http.get<Environment[]>('/assets/customization/environment.json')
            );
            EnvironmentService.environmentList = list || [];
            logger.debug('Environment list loaded:', EnvironmentService.environmentList);
        } catch (err) {
            logger.error('Failed to load environment list:', err);
        }
    }

    private setEnvironment(envName: string, baseUrl: string) {
        sessionStorage.setItem('envName', envName);
        sessionStorage.setItem('baseUrl', baseUrl);
    }

    public getEnvName(): string {
        return sessionStorage.getItem('envName') || 'Default';
    }

    public async showSwitcher() {
        let buttons = [];
        let environmentList: Environment[] = EnvironmentService.environmentList;
        for (let i = 0; i < environmentList.length; i++) {
            let button = {
                text: environmentList[i].name, data: { name: environmentList[i].name, url: environmentList[i].url }
            }
            buttons.push(button);
        }

        buttons.push({
            text: 'Cancel',
            role: 'cancel',
        });

        let envName = this.getEnvName();
        const actionSheet = await this.actionSheetCtrl.create({
            header: `Please select environment (${envName})`,
            buttons: buttons
        });

        await actionSheet.present();

        actionSheet.onDidDismiss().then((item) => {
            if (!item.data) return;
            this.srvUser.logoff(true).subscribe(() => {
                let name = item.data.name;
                let url = item.data.url
                this.setEnvironment(name, url);
                window.location.reload();
            });
        });
    }

    public static getBaseUrl(): string {
        return sessionStorage.getItem('baseUrl') ?? environment.baseUrl;
    }

    public isEnableSwitcher(): boolean {
        if (PlatformService.isBrowser()) return false;
        if (EnvironmentService.environmentList.length == 0) return false;
        if (this.environment.production && this.environment.appType == AppType.PRD) return false;
        return true;
    }

    /**
     * This is required for App store review process.
     * The app will be redirected to the review URL when the user clicks on the "Login" button.
     */
    public static redirectTraffic(reviewUrl: string) {
        sessionStorage.setItem('baseUrl', reviewUrl);
        logger.debug(`Redirect traffic to ${EnvironmentService.getBaseUrl()}`);
    }
}


export interface Environment {
    name: string;
    url: string;
}

export enum AppType {
    UAT = "UAT",
    QA = "QA",
    PRD = "PRD"
}
